import DOMPurify from "dompurify";

const DISALLOWED_TAGS = [
  "script",
  "style",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "link",
  "meta",
];
const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|cid:|\/|#)/i;

const FALLBACK_ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const escapeHtmlFallback = (input: string): string =>
  input.replace(/[&<>"']/g, (char) => FALLBACK_ESCAPE_MAP[char] ?? char);

export function sanitizeEmailHtml(html: string): string {
  if (!html) {
    return "";
  }

  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    // Fail closed outside browser-like runtimes by escaping all markup.
    return escapeHtmlFallback(html);
  }

  const sanitized = DOMPurify.sanitize(html, {
    FORBID_TAGS: DISALLOWED_TAGS,
    ALLOWED_URI_REGEXP: SAFE_URL_PATTERN,
  });

  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, "text/html");

  doc?.body?.querySelectorAll("*").forEach((element) => {
    const tagName = element.tagName.toLowerCase();

    if (tagName === "a") {
      if (element.hasAttribute("href")) {
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noreferrer noopener");
      } else {
        element.removeAttribute("target");
        element.removeAttribute("rel");
      }
      return;
    }

    element.removeAttribute("target");
    element.removeAttribute("rel");
  });

  return doc?.body?.innerHTML ?? "";
}
